/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IDobbiesCustomInlineScriptData } from './dobbies-custom-inline-script.data';
import { IDobbiesCustomInlineScriptProps } from './dobbies-custom-inline-script.props.autogenerated';
import { isNonceEnabled, SDK_FRAGMENT_NAME } from '@msdyn365-commerce/core-internal';
// import { isAbsoluteUrl, isRelativeUrl, logDebug, logError } from '@msdyn365-commerce/core-internal';
export interface IDobbiesCustomInlineScriptViewProps extends IDobbiesCustomInlineScriptProps<IDobbiesCustomInlineScriptData> {}

/**
 *
 * DobbiesCustomInlineScript component
 * @extends {React.PureComponent<IDobbiesCustomInlineScriptProps<IDobbiesCustomInlineScriptData>>}
 */
class DobbiesCustomInlineScript extends React.PureComponent<IDobbiesCustomInlineScriptProps<IDobbiesCustomInlineScriptData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        // logDebug(`Adding script tags for '${this.props.id}/${this.props.typeName}'`, this.props.telemetry);
        const source = config.inlineScript;

        // if (!source || source === '' || isAbsoluteUrl(source) || isRelativeUrl(source)) {
        //     logError(
        //         'Invalid inline script - Empty inline source defined or a url is being used as a source. Use default-external-script to load scripts from an external or relative url.',
        //         this.props.telemetry
        //     );
        //     return null;
        // }

        // if (source.includes('</script>')) {
        //     logError('Invalid inline script - inline script should not contain html tags', this.props.telemetry);
        //     return null;
        // }

        const nonceToken = this.props.context && isNonceEnabled(this.props.context.request);
        const scriptHtml = `<script ${this.props.config.scriptType ? `type=${this.props.config.scriptType}` : ''} ${
            nonceToken ? `nonce='${nonceToken}'` : ''
        }>${source}</script>`;
        return React.createElement(SDK_FRAGMENT_NAME, { key: this.props.id, dangerouslySetInnerHTML: { __html: scriptHtml } });
    }
}

export default DobbiesCustomInlineScript;
